<template>
  <dashboard-page title="Fluxo de Caixa">
    <base-header class="content__title content__title--calendar">
      <b-row align-v="center">
        <b-col class="m-0" cols="8">
          <span class="font-weight-normal text-primary text-center">
            <a
              :readonly="isLoading"
              href="#"
              class="fullcalendar-btn-prev btn btn-sm btn-text py-1 vertical-middle mx-0"
              @click.prevent="prevMonth"
            >
              <i
                class="no no-left-arrow font-size-lg text-primary vertical-middle"
              ></i>
            </a>

            <span
              class="booking-list-period-label font-weight-normal text-primary vertical-middle"
            >
              <span @click="openStartDatePicker">
                {{ periodStartDateLabel }}
              </span>
              <span> - </span>
              <span @click="openEndDatePicker">
                {{ periodEndDateLabel }}
              </span>
            </span>

            <date-picker
              ref="startDatePicker"
              v-model="formDate.startDate"
              type="date"
              format="dd/MM/yy"
              value-format="yyyy-MM-dd"
              :clearable="false"
              :picker-options="pickerOptions"
              class="booking-list-hidden-datepicker"
              @change="onPeriodDateChange"
            />

            <date-picker
              ref="endDatePicker"
              v-model="formDate.endDate"
              type="date"
              format="dd/MM/yy"
              value-format="yyyy-MM-dd"
              :clearable="false"
              :picker-options="pickerOptions"
              class="booking-list-hidden-datepicker"
              @change="onPeriodDateChange"
            />

            <a
              :readonly="isLoading"
              href="#"
              class="fullcalendar-btn-next btn btn-sm btn-text py-1 vertical-middle mx-0"
              @click.prevent="nextMonth"
            >
              <i
                class="no no-right-arrow font-size-lg text-primary vertical-middle"
              ></i>
            </a>
          </span>
        </b-col>

        <b-col cols="4" class="m-0 text-right pl-0">
          <div class="bg-pick d-inline-flex">
            <button
              type="button"
              class="btn btn-letter"
              :class="{ active: headerView === 'contas' }"
              @click="setHeaderView('contas')"
            >
              Contas
            </button>
            <button
              type="button"
              class="btn btn-letter"
              :class="{ active: headerView === 'caixa' }"
              @click="setHeaderView('caixa')"
            >
              Caixa
            </button>
            <button
              type="button"
              class="btn btn-letter"
              :class="{ active: headerView === 'resumo' }"
              @click="setHeaderView('resumo')"
            >
              Resumo
            </button>
          </div>
        </b-col>
      </b-row>
    </base-header>

    <div class="content">
    <b-container fluid class="">
      <div>
        <b-card no-body style="min-height: 180px" ref="day_by_day_wrapper">
          <b-card-body>
            <b-card-title v-if="false" class="h3 mb-0">Resumo</b-card-title>

            <el-tabs v-model="activeName" class="resumo-tabs">
              <el-tab-pane class="" label="Contas" name="first">
                <b-col xs="12" lg="12" md="12" id="chart-dia-dia-container">
                  <div class="accounts-search px-3 mb-3">
                    <div
                      class="d-flex align-items-center w-100"
                      style="
                        padding: 7px;
                        border: 0.5px solid rgb(218, 218, 218);
                        border-radius: 5px;
                        background-color: white;
                      "
                    >
                      <input
                        class="search-input w-100"
                        v-model="accountsSearch"
                        placeholder="filtrar por data, cliente, CPF, produto, pagador..."
                      />
                      <button
                        v-if="accountsSearch"
                        type="button"
                        class="search-field-clear"
                        title="Limpar busca"
                        @click="accountsSearch = ''"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                      <i v-else class="fas fa-search text-muted"></i>
                    </div>
                  </div>

                  <div
                    v-if="filteredParentTransactions.length > 0"
                    ref="parentTransactionsScroll"
                    class="parent-transactions-scroll"
                    @scroll.passive="onParentTransactionsScroll"
                  >
                    <b-row>
                      <b-col
                        v-for="transaction in visibleParentTransactions"
                        :key="transaction.id"
                        cols="12"
                        md="12"
                        lg="12"
                        class="mb-2 mx-0 px-3"
                      >
                        <transaction-card
                          :transaction="transaction"
                          @view-details="viewDetails"
                        ></transaction-card>
                      </b-col>
                    </b-row>

                    <div
                      v-if="hasMoreParentTransactions"
                      class="text-center text-muted small py-2"
                    >
                      Rolando para carregar mais... ({{
                        visibleParentTransactions.length
                      }}/{{ filteredParentTransactions.length }})
                    </div>
                  </div>

                  <div
                    v-else-if="parentTransactions.length > 0"
                    class="text-muted mt-3 px-3"
                  >
                    Nenhuma conta encontrada para esta busca.
                  </div>

                  <div v-else class="text-muted mt-3 px-3">
                    Nenhuma conta encontrada no período.
                  </div>
                </b-col>
              </el-tab-pane>

              <el-tab-pane class="" label="Fluxo diário" name="second">
                <b-col xs="12" lg="12" md="12" id="chart-dia-dia-container">
                  <chart-dia-dia ref="chart_dia_dia"></chart-dia-dia>
                </b-col>
              </el-tab-pane>

              <el-tab-pane :lazy="true" label="Entradas" name="third">
                <b-row>
                  <b-col xs="12" lg="7" md="7">
                    <table-input-by-payment-method :data="dataTableInputByPaymentMethod.methods"
                      headerColor="bg-success pt-2" title="Formas de pagamento">
                    </table-input-by-payment-method>
                  </b-col>

                  <b-col xs="12" lg="5" md="5" align="center">
                    <pie-chart-financeiro :labels="dataTableInputByPaymentMethod.labels"
                      :series="dataTableInputByPaymentMethod.series" style="margin: 0px auto">
                    </pie-chart-financeiro>
                  </b-col>
                </b-row>
              </el-tab-pane>

              <el-tab-pane :lazy="true" label="Saídas" name="fourth">
                <b-row>
                  <b-col xs="12" lg="7" md="7">
                    <table-output-by-categories :data="dataTableOutputByCategories.categories"
                      headerColor="bg-danger pt-2" title="Formas de pagamento">
                    </table-output-by-categories>
                  </b-col>

                  <b-col xs="12" lg="5" md="5" align="center">
                    <pie-chart-financeiro :labels="dataTableOutputByCategories.labels"
                      :series="dataTableOutputByCategories.series" style="margin: 0px auto">
                    </pie-chart-financeiro>
                  </b-col>
                </b-row>
              </el-tab-pane>
            </el-tabs>
          </b-card-body>
        </b-card>
      </div>

      <b-row>
        <b-col lg="7">
          <financeiro-table @loadTransactions="loadTransactions" @openTransactionModal="openTransactionModal"
            headerColor="bg-success pt-2 pb-2" title="Entradas" :startDate="formDate.startDate"
            :endDate="formDate.endDate">
          </financeiro-table>
        </b-col>

        <b-col lg="5">
          <financeiro-output-table @loadTransactions="loadTransactions" headerColor="bg-danger pt-2 pb-2" title="Saídas"
            :startDate="formDate.startDate" :endDate="formDate.endDate">
          </financeiro-output-table>
        </b-col>
      </b-row>

      <transaction-modal v-if="isTransactionModalOpen" @loadTransactions="loadTransactions($event && $event.id, $event && $event.reopenTransactionID)" :currentTransactionID="currentTransactionID"
        :isTransactionModalOpen="isTransactionModalOpen"
        @closeTransactionModal="closeTransactionModal($event)"></transaction-modal>
      <modal-loading :openModal="isFetchingTransaction" :value="'100'" :label="'carregando... '" :variant="'white'"
        :animated="false">
      </modal-loading>
    </b-container>
  </div>
  </dashboard-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import 'vue-good-table/dist/vue-good-table.css'
import ChartDiaDia from './ChartDiaDia'
import PieChartFinanceiro from './PieChartFinanceiro.vue'
import FinanceiroTable from './FinanceiroTable.vue'
import { Tabs, TabPane, DatePicker } from 'element-ui'
import TableInputByPaymentMethod from './TableInputByPaymentMethod.vue'
import TableOutputByCategories from './TableOutputByCategories.vue'
import FinanceiroOutputTable from './FinanceiroOutputTable .vue'
import SearchFilter from './SearchFilter.vue'
import TransactionCard from './TransactionCard.vue'
import TransactionModal from './TransactionModal.vue'
import ModalLoading from '../../components/ModalLoading/ModalLoading.vue'
import moment from 'moment'

export default {
  name: 'Financeiro',

  components: {
    ChartDiaDia,
    TableInputByPaymentMethod,
    TableOutputByCategories,
    FinanceiroTable,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    DatePicker,
    SearchFilter,
    PieChartFinanceiro,
    //DreFinanceiro,
    FinanceiroOutputTable,
    TransactionCard,
    TransactionModal,
    ModalLoading,
  },

  props: {
    pageChanged: {
      type: Function,
    },

    perPageChanged: {
      type: Function,
    },
  },

  data() {
    return {
      rangeLimit: 62,
      formDate: { startDate: '', endDate: '' },

      inputCategories: [],
      outputCategories: [],

      cakeUserParams: null,
      showFilterSearch: false,
      activeName: 'first',
      /** UI-only header toggle (Contas | Caixa | Resumo); no view wiring yet */
      headerView: 'contas',

      loadingChartDiaDia: false,
      perPage: 3,
      currentPage: 1,
      currentTransactionID: null,
      requestArray: [],
      selectedCategories: [],
      selectedOutCategories: [],
      selectedClients: [],
      selectedAgents: [],
      clientsId: [],
      agentsId: [],

      pickerOptions: {
        disabledDate(date) {
          var firstDayOf2024 = moment('2024-01-01')
          return moment(date).isBefore(firstDayOf2024)
        },
      },

      isTransactionModalOpen: false,
      isFetchingTransaction: false,
      parentTransactionsPageSize: 20,
      visibleParentCount: 20,
      accountsSearch: '',
    }
  },

  computed: {
    ...mapGetters('auth', {
      place: 'getPlace',
      user: 'user',
      params: 'params',
    }),

    ...mapGetters('financeiro', {
      agents: 'getAgents',
      clients: 'getClients',
      inputTransactions: 'getInputTransactionsList',
      outputTransactions: 'getOutputTransactionsList',
      responseInputFilter: 'getResponseInputFilter',
      responseOutputFilter: 'getResponseOutputFilter',
      superArrayInputTransactions: 'getSuperArrayInputTransactions',
      superArrayOutputTransactions: 'getSuperArrayOutputTransactions',
      isLoading: 'getIsLoading',
      inputTransaction: 'getInputTransaction',
    }),

    periodStartDateLabel() {
      if (!this.formDate.startDate) return '--'

      const start = moment(this.formDate.startDate)
      if (!start.isValid()) return '--'

      return start.format('DD/MM/YY')
    },

    periodEndDateLabel() {
      if (!this.formDate.endDate) return '--'

      const end = moment(this.formDate.endDate)
      if (!end.isValid()) return '--'

      return end.format('DD/MM/YY')
    },

    parentTransactions() {
      const parentsByPid = new Map()
      const paymentMethodNames = (this.user && this.user.paymentMethods) || {}

        ; (this.inputTransactions || []).forEach((transaction) => {
          if (!transaction) return

          const pid =
            transaction.pid != null ? transaction.pid : transaction.bill_id
          if (pid == null) return

          let xfields = transaction.xfields
          if (typeof xfields === 'string') {
            try {
              xfields = JSON.parse(xfields)
            } catch (error) {
              xfields = null
            }
          }

          const general = xfields && xfields.general
          if (!general && !transaction.flatGlobalSearch) return

          const payments = ((xfields && xfields.payments) || [])
            .filter((payment) => payment && payment.removed !== true)
            .map((payment) => {
              const methodIndex =
                (payment.payment_method && payment.payment_method.index) || 0
              const methodName =
                (payment.payment_method && payment.payment_method.name) ||
                paymentMethodNames[methodIndex] ||
                paymentMethodNames[String(methodIndex)] ||
                ''

              return {
                id: payment.id,
                date: payment.date,
                time: payment.time,
                method: methodName,
                method_index: methodIndex,
                value: payment.value,
                cardFlag: (payment.card_flag && payment.card_flag.label) || '',
                customer_name:
                  payment.customer_name ||
                  transaction.third ||
                  transaction.name ||
                  '',
                customer_document: payment.customer_document || '',
                installments:
                  payment.installments != null && payment.installments !== ''
                    ? payment.installments
                    : '',
                payment_link: payment.payment_link
                  ? payment.payment_link.link
                  : false,
                open: payment.open || false,
              }
            })

          const key = String(pid)
          if (parentsByPid.has(key)) {
            const existing = parentsByPid.get(key)
            if (!transaction.flatGlobalSearch || !existing.flatGlobalSearch) {
              return
            }

            payments.forEach((payment) => {
              const already = existing.payments.some(
                (item) => item.id != null && item.id === payment.id
              )
              if (already) return
              existing.payments.push(payment)
              existing.v =
                Number(existing.v || 0) + Number(payment.value || 0)
            })
            return
          }

          parentsByPid.set(key, {
            id: general && general.id != null ? general.id : pid,
            t:
              (general && general.label) ||
              transaction.t ||
              transaction.description ||
              '',
            d: (general && general.date) || transaction.d || transaction.date,
            user: (general && general.user) || null,
            v: transaction.flatGlobalSearch
              ? Number(
                  transaction.v != null ? transaction.v : transaction.value
                ) || 0
              : general.bill_final_value,
            payments: payments,
            products: ((xfields && xfields.products) || []).filter(
              (product) => product && product.removed !== true
            ),
            flatGlobalSearch: !!transaction.flatGlobalSearch,
          })
        })

      return Array.from(parentsByPid.values()).sort((a, b) => {
        const dateA = moment(a.d)
        const dateB = moment(b.d)
        if (dateA.isValid() && dateB.isValid()) {
          const diff = dateB.valueOf() - dateA.valueOf()
          if (diff !== 0) return diff
        } else if (dateB.isValid()) {
          return 1
        } else if (dateA.isValid()) {
          return -1
        }
        return Number(b.id || 0) - Number(a.id || 0)
      })
    },

    filteredParentTransactions() {
      const list = this.parentTransactions || []
      const tokens = this.normalizeSearchText(this.accountsSearch)
        .split(/\s+/)
        .filter(Boolean)

      if (!tokens.length) return list

      return list.filter((transaction) => {
        const haystack = this.buildTransactionSearchHaystack(transaction)
        return tokens.every((token) => {
          if (haystack.text.includes(token)) return true
          const tokenDigits = String(token).replace(/\D/g, '')
          return (
            tokenDigits.length >= 3 && haystack.digits.includes(tokenDigits)
          )
        })
      })
    },

    visibleParentTransactions() {
      return (this.filteredParentTransactions || []).slice(
        0,
        this.visibleParentCount
      )
    },

    hasMoreParentTransactions() {
      return (
        this.visibleParentCount < (this.filteredParentTransactions || []).length
      )
    },

    dataTableInputByPaymentMethod() {
      let paymentMethodTemp = this.user.paymentMethods || {}
      let widgetInputByPaymentMethod = []

      Object.keys(paymentMethodTemp).forEach((pm) => {
        widgetInputByPaymentMethod[pm] = {
          paymentMethod: pm,
          label: paymentMethodTemp[pm],
          value: 0,
          percent: 0,
        }
      })

      widgetInputByPaymentMethod = widgetInputByPaymentMethod.filter(
        (cat, index) => widgetInputByPaymentMethod.indexOf(cat) == index
      )

      if (this.superArrayInputTransactions) {
        Object.keys(this.superArrayInputTransactions).forEach((day) => {
          if (
            this.superArrayInputTransactions[day] &&
            this.superArrayInputTransactions[day].by_payment_metod
          ) {
            let dayPaymentMethods =
              this.superArrayInputTransactions[day].by_payment_metod

            Object.entries(dayPaymentMethods).forEach((dayPaymentMethod) => {
              let filteredpm = widgetInputByPaymentMethod.find((pm) => {
                if (pm) {
                  return pm.paymentMethod === dayPaymentMethod[0]
                } else {
                  return false
                }
              })

              filteredpm ? (filteredpm.value += dayPaymentMethod[1]) : ''
            })
          }
        })
      }

      widgetInputByPaymentMethod = widgetInputByPaymentMethod.filter(
        (item) => item != undefined
      )

      var labels = widgetInputByPaymentMethod.map(({ label }) => label)
      var series = widgetInputByPaymentMethod.map(({ value }) =>
        Number(value.toFixed(2))
      )
      var methods = widgetInputByPaymentMethod

      return { labels: labels, series: series, methods: methods }
    },

    dataTableOutputByCategories() {
      let paymentMethodTemp = this.user.paymentMethods || {}
      let widgetOutputByPaymentMethod = []

      Object.keys(paymentMethodTemp).forEach((pm) => {
        widgetOutputByPaymentMethod[pm] = {
          paymentMethod: pm,
          label: paymentMethodTemp[pm],
          value: 0,
          percent: 0,
        }
      })

      widgetOutputByPaymentMethod = widgetOutputByPaymentMethod.filter(
        (cat, index) => widgetOutputByPaymentMethod.indexOf(cat) == index
      )

      if (this.superArrayOutputTransactions) {
        Object.keys(this.superArrayOutputTransactions).forEach((day) => {
          if (
            this.superArrayOutputTransactions[day] &&
            this.superArrayOutputTransactions[day].by_payment_metod
          ) {
            let dayPaymentMethods =
              this.superArrayOutputTransactions[day].by_payment_metod

            Object.entries(dayPaymentMethods).forEach((dayPaymentMethod) => {
              let filteredpm = widgetOutputByPaymentMethod.find((pm) => {
                if (pm) {
                  return pm.paymentMethod === dayPaymentMethod[0]
                } else {
                  return false
                }
              })

              filteredpm ? (filteredpm.value += dayPaymentMethod[1]) : ''
            })
          }
        })
      }

      widgetOutputByPaymentMethod = widgetOutputByPaymentMethod.filter(
        (item) => item != undefined
      )

      var labels = widgetOutputByPaymentMethod.map(({ label }) => label)
      var series = widgetOutputByPaymentMethod.map(({ value }) =>
        Number(value.toFixed(2))
      )
      var categories = widgetOutputByPaymentMethod

      return { labels: labels, series: series, categories: categories }
    },
  },

  watch: {
    inputTransactions(newValue) {
      if (newValue) {
        this.rebuildSuperArrays()
      }
    },

    outputTransactions(newValue) {
      if (newValue) {
        this.rebuildSuperArrays()
      }
    },

    parentTransactions() {
      this.visibleParentCount = this.parentTransactionsPageSize
      this.$nextTick(() => {
        this.fillParentTransactionsViewport()
      })
    },

    accountsSearch() {
      this.visibleParentCount = this.parentTransactionsPageSize
      this.$nextTick(() => {
        this.fillParentTransactionsViewport()
      })
    },
  },

  methods: {
    ...mapActions('financeiro', [
      'fetchAgents',
      'fetchClients',
      'fetchTransactions',
      'fetchTransactionById',
      'resetTransactions',
      'financeiroStoreCommit',
      'setIsLoading',
    ]),

    normalizeSearchText(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
    },

    pushSearchValues(parts, value) {
      if (value == null || value === false || value === '') return
      if (typeof value === 'object') return
      parts.push(String(value))
    },

    pushSearchDate(parts, value) {
      if (!value) return
      this.pushSearchValues(parts, value)
      const date = moment(value)
      if (!date.isValid()) return
      this.pushSearchValues(parts, date.format('DD/MM/YYYY'))
      this.pushSearchValues(parts, date.format('DD/MM/YY'))
      this.pushSearchValues(parts, date.format('YYYY-MM-DD'))
    },

    buildTransactionSearchHaystack(transaction) {
      const parts = []

      this.pushSearchValues(parts, transaction.id)
      this.pushSearchValues(parts, `C${transaction.id}`)
      this.pushSearchValues(parts, transaction.t)
      this.pushSearchValues(parts, transaction.v)
      this.pushSearchDate(parts, transaction.d)
      this.pushSearchValues(
        parts,
        transaction.user && transaction.user.name
      )
      this.pushSearchValues(
        parts,
        transaction.user && transaction.user.email
      )

      ;(transaction.payments || []).forEach((payment) => {
        this.pushSearchValues(parts, payment.customer_name)
        this.pushSearchValues(parts, payment.customer_document)
        this.pushSearchValues(parts, payment.method)
        this.pushSearchValues(parts, payment.cardFlag)
        this.pushSearchValues(parts, payment.value)
        this.pushSearchValues(parts, payment.payment_link)
        this.pushSearchDate(parts, payment.date)
      })

      ;(transaction.products || []).forEach((product) => {
        const item = (product && product.item) || {}
        const nestedProduct = item.product || {}
        const booking = (product && product.booking) || {}
        const costumer = booking.costumer || {}
        const phone = costumer.phone || {}

        this.pushSearchValues(parts, item.product_name)
        this.pushSearchValues(parts, nestedProduct.product_name)
        this.pushSearchValues(parts, item.type)
        this.pushSearchValues(parts, booking.product_place)
        this.pushSearchValues(parts, booking.booking_code)
        this.pushSearchDate(parts, booking.date)
        this.pushSearchValues(parts, costumer.name)
        this.pushSearchValues(parts, costumer.email)
        this.pushSearchValues(parts, costumer.cpf)
        this.pushSearchValues(parts, phone.area_code)
        this.pushSearchValues(parts, phone.number)
        if (phone.area_code || phone.number) {
          this.pushSearchValues(
            parts,
            `${phone.area_code || ''}${phone.number || ''}`
          )
        }
      })

      const joined = parts.join(' ')
      return {
        text: this.normalizeSearchText(joined),
        digits: String(joined).replace(/\D/g, ''),
      }
    },

    waitForRender() {
      return this.$nextTick().then(() => {
        return new Promise((resolve) => {
          requestAnimationFrame(() => {
            requestAnimationFrame(resolve)
          })
        })
      })
    },

    async finishLoading() {
      // Espera Vue atualizar o DOM (el-tabs / TransactionCards) e o browser pintar
      await this.waitForRender()
      this.isFetchingTransaction = false
      this.setIsLoading(false)
    },

  openTransactionModal(currentTransactionID = null) {
    console.log('openTransactionModal', currentTransactionID)
      this.currentTransactionID = currentTransactionID
      this.isTransactionModalOpen = true
    },

    closeTransactionModal() {
      this.isTransactionModalOpen = false
    },

    loadMoreParentTransactions() {
      if (!this.hasMoreParentTransactions) return

      this.visibleParentCount = Math.min(
        this.visibleParentCount + this.parentTransactionsPageSize,
        this.filteredParentTransactions.length
      )
    },

    onParentTransactionsScroll(event) {
      const el = event && event.target
      if (!el || !this.hasMoreParentTransactions) return

      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 80
      if (nearBottom) {
        this.loadMoreParentTransactions()
      }
    },

    fillParentTransactionsViewport() {
      const el = this.$refs.parentTransactionsScroll
      if (!el || !this.hasMoreParentTransactions) return

      // Se a lista inicial não preenche a área, carrega mais até preencher ou acabar
      if (el.scrollHeight <= el.clientHeight + 80) {
        this.loadMoreParentTransactions()
        this.$nextTick(() => this.fillParentTransactionsViewport())
      }
    },

    async viewDetails(reopenTransactionData = null) {
      console.log('viewDetails', reopenTransactionData,this.inputTransaction.general.id)
      this.financeiroStoreCommit({ mutation: 'RESET_TRANSACTION' })
      sessionStorage.removeItem('stored_transaction')
      const id = this.inputTransaction.general.id || reopenTransactionData.id
      console.log('id', id)
      if(!id){
        console.log('no id')
        return
      }
      if(reopenTransactionData.reopenTransactionID){
        console.log('loading reopenTransactionID', reopenTransactionData.reopenTransactionID)
        this.isFetchingTransaction = true
      }
      await this.fetchTransactionById({
        pid: id,
        type: '1',
      })
        .then(() => {
          console.log('reopenTransactionData', reopenTransactionData)
          if (this.inputTransaction.general.id ) {
            console.log('openTransactionModal', reopenTransactionData.reopenTransactionID?reopenTransactionData.reopenTransactionID:  reopenTransactionData.id)
            this.openTransactionModal(reopenTransactionData.reopenTransactionID?reopenTransactionData.reopenTransactionID:reopenTransactionData.id)
          }

          this.inputTransaction.products.forEach((product) => {
            if (['Passeio', 'Experiência','Evento'].includes(product.item.type)) {
              if (!product.booking.costumer) {
                product.booking.costumer = {
                  name: this.inputTransaction.payments[0].customer_name,
                  email: '',
                  cpf: this.inputTransaction.payments[0].customer_document,
                  phone: {
                    area_code: '',
                    number: '',
                  },
                }
              }
            }
          })
        })
        .finally(() => {
          console.log('finally', this.isFetchingTransaction,reopenTransactionData,this.inputTransaction.general.id)
          this.isFetchingTransaction = false
        })
    },

    setHeaderView(view) {
      // UI only — Contas | Caixa | Resumo still do not switch content
      if (!view) return
      this.headerView = view
    },

    prevMonth() {
      const reference = moment(this.formDate.startDate).subtract(1, 'month')
      this.formDate.startDate = reference.startOf('month').format('YYYY-MM-DD')
      this.formDate.endDate = reference.endOf('month').format('YYYY-MM-DD')
      this.loadTransactions(null, true)
    },

    nextMonth() {
      const reference = moment(this.formDate.startDate).add(1, 'month')
      this.formDate.startDate = reference.startOf('month').format('YYYY-MM-DD')
      this.formDate.endDate = reference.endOf('month').format('YYYY-MM-DD')
      this.loadTransactions(null, true)
    },

    openStartDatePicker() {
      const picker = this.$refs.startDatePicker
      if (!picker) return

      // Element UI DatePicker: abre o painel sem exibir o input
      if (typeof picker.focus === 'function') {
        picker.focus()
      }
      picker.pickerVisible = true
    },

    openEndDatePicker() {
      const picker = this.$refs.endDatePicker
      if (!picker) return

      // Element UI DatePicker: abre o painel sem exibir o input
      if (typeof picker.focus === 'function') {
        picker.focus()
      }
      picker.pickerVisible = true
    },

    onPeriodDateChange() {
      this.loadTransactions(null, true)
    },

    isTransactionToReopen(value) {
      if (!value) return false
      if (value == 'last') return true
      const id = Number(value)
      return Number.isInteger(id) && id > 0
    },

    async loadTransactions(id , reopenTransaction) {
      console.log('financeiro loadTransactions', id, reopenTransaction)
      this.isFetchingTransaction = true
      this.setIsLoading(true)

      try {
        var { startDate: formStartDate, endDate: formEndDate } = this.formDate
        var sDate = new Date(formStartDate + 'T12:00:00')
        var eDate = new Date(formEndDate + 'T12:00:00')
        var diff = moment(this.formDate.endDate).diff(
          moment(this.formDate.startDate),
          'days'
        )

        if (diff < 0) {
          this.$notify({
            message:
              'A data final deve ser após a data inicial. Intervalo ajustado!',
            duration: 6000,
            type: 'warning',
          })
          this.formDate.endDate = moment(this.formDate.startDate).format(
            'YYYY-MM-DD'
          )
          sDate = new Date(this.formDate.startDate + 'T12:00:00')
          eDate = new Date(this.formDate.endDate + 'T12:00:00')
        } else if (diff > this.rangeLimit) {
          this.$notify({
            message:
              'O intervalo de datas não pode ser maior que ' + this.rangeLimit + ' dias. Intervalo ajustado!',
            duration: 6000,
            type: 'warning',
          })
          sDate = new Date(this.formDate.startDate + 'T12:00:00')
          if (this.formDate.startDate.endsWith('-01')) {
            this.formDate.endDate = moment(this.formDate.startDate)
              .endOf('month')
              .format('YYYY-MM-DD')
            eDate = new Date(this.formDate.endDate + 'T12:00:00')
          } else {
            eDate = new Date(
              moment(this.formDate.startDate)
                .add(this.rangeLimit, 'days')
                .format('YYYY-MM-DD') + 'T12:00:00'
            )
            this.formDate.endDate = moment(this.formDate.startDate)
              .add(this.rangeLimit, 'days')
              .format('YYYY-MM-DD')
          }
        }

        this.requestArray = []
        // 0 -> Output
        // 1 -> Input
        this.resetTransactions()

        let superArrays = this.createSuperArrays(sDate, eDate)
        this.financeiroStoreCommit({
          mutation: 'SET_SUPER_ARRAY_INPUT_TRANSACTIONS',
          value: superArrays.input,
        })
        this.financeiroStoreCommit({
          mutation: 'SET_SUPER_ARRAY_OUTPUT_TRANSACTIONS',
          value: superArrays.output,
        })
        await this.fetchTransactions({
          startDate: sDate,
          endDate: eDate,
          daysInternval: 1,
          inputOutput: '0',
        }) // 0 -> Output
        await this.fetchTransactions({
          startDate: sDate,
          endDate: eDate,
          daysInternval: 1,
          inputOutput: '1',
        }) // 1 -> Input

        this.rebuildSuperArrays(sDate, eDate)
      } finally {
        console.log('financeiro loadTransactions finally', id, reopenTransaction, this.isTransactionToReopen(reopenTransaction))
        await this.finishLoading()
        if (id || this.isTransactionToReopen(reopenTransaction)) {
          this.viewDetails({id: id, reopenTransactionID: reopenTransaction})
        }else{
          this.viewDetails({id: id, reopenTransactionID: 'last'})
        }
      }
    },

    rebuildSuperArrays(startDate, endDate) {
      const start = startDate || this.formDate.startDate
      const end = endDate || this.formDate.endDate
      const superArrays = this.createSuperArrays(start, end)

      this.financeiroStoreCommit({
        mutation: 'SET_SUPER_ARRAY_INPUT_TRANSACTIONS',
        value: superArrays.input,
      })
      this.financeiroStoreCommit({
        mutation: 'SET_SUPER_ARRAY_OUTPUT_TRANSACTIONS',
        value: superArrays.output,
      })

      this.financeiroStoreCommit({
        mutation: 'SET_SUPER_ARRAY_INPUT_TRANSACTIONS',
        value: this.fillSuperArraysInput(),
      })
      this.financeiroStoreCommit({
        mutation: 'SET_SUPER_ARRAY_OUTPUT_TRANSACTIONS',
        value: this.fillSuperArraysOutput(),
      })
    },

    getPaymentMethods() {
      const paymentMethods = this.user.paymentMethods || {}

      const keys = Object.keys(paymentMethods)
      const values = new Array(keys.length).fill(0)

      return values.reduce((result, field, index) => {
        result[keys[index]] = field
        return result
      }, {})
    },

    initializeNestedCategories(categories) {
      const nestedCategories = {}

      categories.forEach((category) => {
        const subCategories = category.split(': ')
        let pointer = nestedCategories

        subCategories.reduce((currentPointer, subCategory, index) => {
          if (!currentPointer[subCategory]) {
            currentPointer[subCategory] = { total: 0 }

            subCategories.slice(index + 1).reduce((subPointer, subcat) => {
              subPointer[subcat] = { total: 0 }
              return subPointer[subcat]
            }, currentPointer[subCategory])
          }

          return currentPointer[subCategory]
        }, pointer)
      })

      return nestedCategories
    },

    generateDaysArray(startDate, endDate) {
      var daysArraySize = moment(endDate).diff(moment(startDate), 'days') + 1
      var daysArray = [...new Array(daysArraySize)]
      daysArray = daysArray.map((_, i) =>
        moment(startDate).add(i, 'days').format('YYYY-MM-DD')
      ) // TRANSFORM daysArray INTO ARRAY OF DATE STRINGS
      return daysArray
    },

    initializeSuperArrays(
      daysArray,
      byPaymentMethods,
      byInputCategories,
      byOutputCategories
    ) {
      let superArrayInputTransactions = {}
      let superArrayOutputTransactions = {}

      daysArray.forEach((start_date) => {
        superArrayInputTransactions[start_date] = {
          by_payment_metod: {
            ...JSON.parse(JSON.stringify(byPaymentMethods)),
            total: 0,
          },
          by_categories: {
            ...JSON.parse(JSON.stringify(byInputCategories)),
            total: 0,
          },
          total: 0,
        }

        superArrayOutputTransactions[start_date] = {
          by_payment_metod: {
            ...JSON.parse(JSON.stringify(byPaymentMethods)),
            total: 0,
          },
          by_categories: {
            ...JSON.parse(JSON.stringify(byOutputCategories)),
            total: 0,
          },
          total: 0,
        }
      })

      superArrayInputTransactions.total = 0
      superArrayOutputTransactions.total = 0

      return {
        input: superArrayInputTransactions,
        output: superArrayOutputTransactions,
      }
    },

    createSuperArrays(startDate, endDate) {
      var byPaymentMethods = this.getPaymentMethods()

      let byInputCategories = this.initializeNestedCategories(
        this.inputCategories
      )
      let byOutputCategories = this.initializeNestedCategories(
        this.outputCategories
      )
      let daysArray = this.generateDaysArray(startDate, endDate)
      let superArrays = this.initializeSuperArrays(
        daysArray,
        byPaymentMethods,
        byInputCategories,
        byOutputCategories
      )

      return superArrays
      // this.financeiroStoreCommit({ mutation: "SET_SUPER_ARRAY_INPUT_TRANSACTIONS", value: superArrays.input })
      // this.financeiroStoreCommit({ mutation: "SET_SUPER_ARRAY_OUTPUT_TRANSACTIONS", value: superArrays.output })
    },

    fillSuperArraysInput() {
      var superArrayInputTransactions = JSON.parse(
        JSON.stringify(this.superArrayInputTransactions)
      )

      if (this.inputTransactions && this.inputTransactions.length > 0) {
        this.inputTransactions.forEach((transaction) => {
          if (!transaction) return
          if (superArrayInputTransactions[transaction.p]) {
            //total: period
            superArrayInputTransactions.total += Number(
              parseFloat(transaction.v).toFixed(2)
            )
            //total: day
            superArrayInputTransactions[transaction.p].total += Number(
              parseFloat(transaction.v).toFixed(2)
            )

            //payment_method: by method
            if (
              superArrayInputTransactions[transaction.p].by_payment_metod[
              transaction.pm
              ] !== undefined
            ) {
              superArrayInputTransactions[transaction.p].by_payment_metod[
                transaction.pm
              ] += Number(parseFloat(transaction.v).toFixed(2))
            } else {
              superArrayInputTransactions[transaction.p].by_payment_metod[
                '0'
              ] += Number(parseFloat(transaction.v).toFixed(2))
            }

            //payment_method: total
            superArrayInputTransactions[transaction.p].by_payment_metod.total +=
              Number(parseFloat(transaction.v).toFixed(2))
          }
        })
      }

      return superArrayInputTransactions
    },

    fillSuperArraysOutput() {
      var superArrayOutputTransactions = JSON.parse(
        JSON.stringify(this.superArrayOutputTransactions)
      )

      if (this.outputTransactions && this.outputTransactions.length > 0) {
        this.outputTransactions.forEach((transaction) => {
          if (!transaction) return
          if (
            this.selectedOutCategories.length > 0 ||
            this.selectedAgents.length > 0
          ) {
            if (superArrayOutputTransactions[transaction.d]) {
              superArrayOutputTransactions.total += Number(
                parseFloat(transaction.v).toFixed(2)
              ) //total: period
              superArrayOutputTransactions[transaction.d].total += Number(
                parseFloat(transaction.v).toFixed(2)
              ) //total: day

              //payment_method: by method
              if (
                superArrayOutputTransactions[transaction.d].by_payment_metod[
                transaction.pm
                ] !== undefined
              ) {
                superArrayOutputTransactions[transaction.d].by_payment_metod[
                  transaction.pm
                ] += Number(parseFloat(transaction.v).toFixed(2))
              } else {
                superArrayOutputTransactions[transaction.d].by_payment_metod[
                  '0'
                ] += Number(parseFloat(transaction.v).toFixed(2))
              }

              //payment_method: total
              superArrayOutputTransactions[
                transaction.d
              ].by_payment_metod.total += Number(
                parseFloat(transaction.v).toFixed(2)
              )
            }
          } else {
            if (superArrayOutputTransactions[transaction.d]) {
              superArrayOutputTransactions.total += Number(
                parseFloat(transaction.v).toFixed(2)
              ) //total: period
              superArrayOutputTransactions[transaction.d].total += Number(
                parseFloat(transaction.v).toFixed(2)
              ) //total: day

              //payment_method: by method
              if (
                superArrayOutputTransactions[transaction.d].by_payment_metod[
                transaction.pm
                ] !== undefined
              ) {
                superArrayOutputTransactions[transaction.d].by_payment_metod[
                  transaction.pm
                ] += Number(parseFloat(transaction.v).toFixed(2))
              } else {
                superArrayOutputTransactions[transaction.d].by_payment_metod[
                  '0'
                ] += Number(parseFloat(transaction.v).toFixed(2))
              }

              //payment_method: total
              superArrayOutputTransactions[
                transaction.d
              ].by_payment_metod.total += Number(
                parseFloat(transaction.v).toFixed(2)
              )
            }
          }
        })
      }

      return superArrayOutputTransactions
    },

    setInputCategories(cats) {
      this.selectedCategories = cats
    },
    setOutputCategories(outCats) {
      this.selectedOutCategories = outCats
    },
    setClients(cliente) {
      this.selectedClients = cliente
    },
    setAgents(agente) {
      this.selectedAgents = agente
    },

    fetchFilterTransactions() {
      this.financeiroStoreCommit({
        mutation: 'SET_INPUT_TRANSACTIONS',
        value: [],
      })
      this.financeiroStoreCommit({
        mutation: 'SET_OUTPUT_TRANSACTIONS',
        value: [],
      })

      if (
        this.selectedClients.length > 0 ||
        this.selectedCategories.length > 0
      ) {
        this.financeiroStoreCommit({
          mutation: 'SET_INPUT_TRANSACTIONS',
          value: [],
        })
        var widgetInputTemp = []
        var widgetClientes = []

        const selectedClientsSet = new Set(this.selectedClients)
        this.clientsId = this.clients
          .filter((element) => selectedClientsSet.has(element.n))
          .map((element) => element.id)

        const selectedCategoriesSet = new Set(this.selectedCategories)
        widgetInputTemp = this.responseInputFilter.filter((element) =>
          selectedCategoriesSet.has(element.cat)
        )

        const clientsIdSet = new Set(this.clientsId)
        widgetClientes = this.responseInputFilter.filter((element) =>
          clientsIdSet.has(element.cid)
        )
        widgetInputTemp = widgetClientes.map((element) => ({
          responseInput: element,
        }))

        this.financeiroStoreCommit({
          mutation: 'SET_INPUT_TRANSACTIONS',
          value: widgetInputTemp.concat(widgetClientes),
        })
      }

      if (
        this.selectedOutCategories.length > 0 ||
        this.selectedAgents.length > 0
      ) {
        this.financeiroStoreCommit({
          mutation: 'SET_OUTPUT_TRANSACTIONS',
          value: [],
        })
        var widgetOutTemp = []
        var widgetAgents = []

        const selectedOutCategoriesSet = new Set(this.selectedOutCategories)
        widgetOutTemp = this.responseOutputFilter.filter((element) =>
          selectedOutCategoriesSet.has(element.cat)
        )

        this.selectedAgents.forEach((selectedAgent) => {
          const matchingAgent = this.agents.find(
            (agent) => agent.n === selectedAgent
          )
          if (matchingAgent) {
            this.agentsId.push(matchingAgent.id)
          }
        })

        const agentsIdSet = new Set(this.agentsId)
        widgetAgents = this.responseOutputFilter.filter((element) =>
          agentsIdSet.has(element.aid)
        )

        this.financeiroStoreCommit({
          mutation: 'SET_OUTPUT_TRANSACTIONS',
          value: widgetOutTemp.concat(widgetAgents),
        })
      }

      this.rebuildSuperArrays()
    },

    fillTableDreFinanceiro() {
      Object.entries(this.superArrayInputTransactions).forEach(
        (by_categories) => {
          //if (dayOutputCategories[0] === "total") {
          let dayInputCategories = by_categories
          let categoriesTemp = dayInputCategories[1].by_categories
        }
      )
    },
  },

  async mounted() {
    await this.fetchAgents()
    await this.fetchClients()
    await this.loadTransactions()

    this.cakeUserParams = this.params

    this.inputCategories =
      typeof this.cakeUserParams.User.transaction_input_categories == 'string'
        ? [this.cakeUserParams.User.transaction_input_categories]
        : []
    this.inputCategories['Vendas'] = 'Vendas' //Input transactions category to bills
    this.inputCategories['Outros'] = 'Outros' //Input transactions default
    this.inputCategories = Object.values(this.inputCategories)

    //Output transactions default
    this.outputCategories =
      this.cakeUserParams.User.transaction_categories || []
    if(typeof this.outputCategories === 'string') {
      this.outputCategories = new Array(this.outputCategories)
    }
    this.outputCategories['Outros'] = 'Outros'
    this.outputCategories = Object.values(this.outputCategories)
  },

  created() {
    this.formDate.startDate = moment().startOf('M').format('YYYY-MM-DD') // setting first day of current month as picker start date
    this.formDate.endDate = moment().endOf('M').format('YYYY-MM-DD') // setting today as picker end date

    // TransactionModal emite 'loadTransactions' no componente pai ao salvar/excluir
    this.$on('loadTransactions', this.loadTransactions)
  },
}
</script>

<style>
.scroll {
  max-width: 1200px;
  min-height: 350px;
  overflow-y: auto;
}

.bg-pick {
  background-color: white;
  height: 25px;
  width: fit-content;
  display: flex;
  align-items: center;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 4px;
}

.btn-letter.active {
  background: #12576e;
  color: #fff;
}

.booking-list-period-label {
  cursor: pointer;
  user-select: none;
}

.booking-list-period-label span:hover {
  text-decoration: underline;
}

.booking-list-hidden-datepicker {
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  opacity: 0 !important;
  overflow: hidden !important;
  pointer-events: none !important;
}

.booking-list-hidden-datepicker .el-input__inner {
  padding: 0 !important;
  height: 0 !important;
  line-height: 0 !important;
  border: none !important;
}

.resumo-tabs .el-tab-pane {
  overflow-y: auto;
  overflow-x: auto;
}

.parent-transactions-scroll {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.accounts-search {
  max-width: 100%;
}

.accounts-search .form-group {
  margin-bottom: 0;
}

.apexcharts-toolbar {
  z-index: 9 !important;
}

.card.bg-transparent {
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
  border-radius: 0;
}

.card .el-table th {
  padding-left: 0rem;
  padding-right: 0rem;
}

.card-header .btn-primary,
.card-header .btn-primary:hover {
  border-color: #fff;
  background-color: transparent;
  color: transparent;
  box-shadow: none;
  padding-top: 4px;
  padding-bottom: 0px;
}
</style>
